import DynamicAssociationSummaryViewModelT from '@/ViewModels/SummaryViews/DynamicAssociationSummaryViewModel';
import SummaryViewFactory from '@/Factories/SummaryViewFactory';
import ComponentManager from '@/Management/ComponentManager';
export default class DynamicAssociationSummaryViewFactory extends SummaryViewFactory {
    public viewModel: any;
    private summaryView: any;
    private DynamicAssociationSummaryViewModel: any;
    private DynamicAssociationSummaryView: any;
    constructor(params: any) {
        super(params);
        this.DynamicAssociationSummaryViewModel = ComponentManager.getViewModel<typeof DynamicAssociationSummaryViewModelT>('DynamicAssociationSummaryViewModel');
        this.DynamicAssociationSummaryView = ComponentManager.getSummaryView('DynamicAssociationSummaryView');
    }
    public getSummaryView(): any {
        if (this.summaryView != null) {
            return this.summaryView;
        }
        this.viewModel = new this.DynamicAssociationSummaryViewModel({
            name: this.genericObject.getObservable('Name'),
            to_ACardinalityValue: this.genericObject.getObservable('to_A.Cardinality.Value'),
            to_AName: this.genericObject.getObservable('to_A.Name'),
            to_AOrderedList: this.genericObject.getObservable('to_A.OrderedList'),
            to_APDTypeMetaName: this.genericObject.getObservable('to_A.PDTypeMeta.Name'),
            to_APDTypeMetaPDO_ID: this.genericObject.getObservable('to_A.PDTypeMeta.PDO_ID'),
            to_BCardinalityValue: this.genericObject.getObservable('to_B.Cardinality.Value'),
            to_BName: this.genericObject.getObservable('to_B.Name'),
            to_BOrderedList: this.genericObject.getObservable('to_B.OrderedList'),
            to_BPDTypeMetaName: this.genericObject.getObservable('to_B.PDTypeMeta.Name'),
            to_BPDTypeMetaPDO_ID: this.genericObject.getObservable('to_B.PDTypeMeta.PDO_ID')
        });
        this.summaryView = new this.DynamicAssociationSummaryView(this.viewModel);
        let tuple = this.summaryView.getTuple();
        this.summaryView = tuple.summaryView;
        return this.summaryView;
    }
    public getNeededProperties(): any {
        return [
            'Name',
            'to_A.Cardinality.Value',
            'to_A.Name',
            'to_A.OrderedList',
            'to_A.PDTypeMeta.Name',
            'to_A.PDTypeMeta.PDO_ID',
            'to_B.Cardinality.Value',
            'to_B.Name',
            'to_B.OrderedList',
            'to_B.PDTypeMeta.Name',
            'to_B.PDTypeMeta.PDO_ID'
        ];
    }
}

ComponentManager.setFactory('DynamicAssociationSummaryView', DynamicAssociationSummaryViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setFactory('RADPresentation.Views.ViewModels.DynamicAssoziationViewModel', DynamicAssociationSummaryViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');